import { normalizeSellablePricing, NormalizationOptions } from '#src/services/sellable'
import {
  TrackableSellableFragment,
  TrackableSellableWithDefaultVariantFragment,
  TrackableOrderFragment,
  MyselfFragment,
  ContactType
} from '#src/generated/graphql'

export function getSellableEcommerceProperties(
  sellable: TrackableSellableFragment | TrackableSellableWithDefaultVariantFragment,
  additionalData?: {},
  pricingNormalizationOptions: NormalizationOptions = {}
): Tracking.SellableProperties {
  const sellableCategory = sellable.categories[0]
  const normalizedPricing = normalizeSellablePricing(sellable, pricingNormalizationOptions)

  return {
    brand: sellable.brand ? sellable.brand.displayName : undefined,
    brand_id: sellable.brand ? sellable.brand.id : undefined,
    category: sellableCategory.slug,
    category_id: sellableCategory.id,
    currency: 'USD',
    image_url: sellable.images.length ? sellable.images[0].url : undefined,
    name: sellable.title,
    product_id: sellable.feedId,
    price: normalizedPricing && normalizedPricing.price.amount,
    sellable_id: sellable.id,
    sku: sellable.googleId,
    url: `/sellable/${sellable.id}`,
    ...additionalData
  }
}

export function getOrderEcommerceProperties(
  order: TrackableOrderFragment,
  additionalData?: {}
): Tracking.OrderProperties {
  const products: Tracking.OrderProperties['products'] = []
  const promotionName = order.appliedPromotionEntry
    ? order.appliedPromotionEntry.promotion.code
    : undefined

  order.lineItems.forEach(item => {
    if (item.source.__typename !== 'OrderLineItemSellableSource') {
      return null
    }

    // TODO: Track AdHoc sources
    products.push({
      quantity: item.quantity,
      ...getSellableEcommerceProperties(item.source.sellable)
    })
  })

  return {
    coupon: promotionName,
    currency: 'USD',
    order_id: order.id,
    products,
    shipping: order.totalShippingCost ? order.totalShippingCost.amount : null,
    subtotal: order.subtotal.amount,
    tax: order.tax ? order.tax.amount : null,
    tip: order.tip ? order.tip.amount : null,
    total: order.totalCost.amount,
    value: order.totalCost.amount,
    ...additionalData
  }
}

export type UserRequestAttributes = {
  city?: string
  email?: string
  first_name?: string
  last_name?: string
  phone?: string
  state?: string
  zip?: string
}

export function getUserRequestAttributesFromMyself(myself?: MyselfFragment): UserRequestAttributes {
  if (!myself) {
    return {}
  }

  const userPhone = myself.user.contacts.find(contact => contact.type === ContactType.PHONE)
  const userEmail = myself.user.contacts.find(contact => contact.type === ContactType.EMAIL)
  const userAddress = myself.user.address || null

  return {
    city: userAddress?.city || undefined,
    email: userEmail?.value,
    first_name: myself.realUser.firstName || undefined,
    last_name: myself.realUser.lastName || undefined,
    phone: userPhone?.value,
    state: userAddress?.state || undefined,
    zip: userAddress?.postalCode
  }
}
